<template>
  <div>
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>
          {{
            ["OCPR", "OCPE"].includes(activity)
              ? "5. ANEXOS A INCLUIR A ESTA SOLICITUD"
              : ["CSGAS", "OCSG", "CSA", "CSIA", "OCLN"].includes(activity)
              ? "4.6 ANEXOS A INCLUIR A ESTA SOLICITUD"
              : ["OINSP"].includes(activity)
              ? "5.8 ANEXOS A INCLUIR A ESTA SOLICITUD"
              : ["OENY", "OEYC"].includes(activity)
              ? "5.7 ANEXOS A INCLUIR A ESTA SOLICITUD"
              : ["OEAP"].includes(activity)
              ? "4.4 ANEXOS A INCLUIR A ESTA SOLICITUD"
              : ["OICC"].includes(activity)
              ? "4.5 ANEXOS A INCLUIR A ESTA SOLICITUD"
              : ""
          }}
        </h5>
      </legend>
    </div>

    <AnnexedList />

    <div v-if="['OEAP'].includes(activity)">
      <legend class="col-form-label text-primary pt-0 my-3">
        <h5>INFORMACIÓN DE ANEXOS</h5>
      </legend>

      <TestEquipment
        :disabled="disabled"
        title="ANEXO 6. LISTADO DE EQUIPOS DE ENSAYO"
      />

      <subcontractors-table
        title="ANEXO 8. LISTADO DE SUBCONTRATISTAS"
        tableId="subcontractors-table"
        modalTitle="Añadir subcontratista"
        editModalTitle="Editar subcontratista"
        :activity="activity"
        :disabled="disabled"
      />

      <ProfTestInter
        :disabled="disabled"
        :activity="activity"
        title="ANEXO 9. LISTADO DE RONDAS DE INTERCOMPARACIÓN Y/O ENSAYOS DE APTITUD EJECUTADOS"
      />

      <rehearsal-activities-table
        title="ANEXO 13. LISTADO DE PERSONAL RELACIONADO CON LA ACREDITACIÓN"
        tableId="rehearsal-activities-table"
        modalTitle="Añadir personal"
        editModalTitle="Editar personal"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <div v-if="['OICC'].includes(activity)">
      <legend class="col-form-label text-primary pt-0 my-3">
        <h5>INFORMACIÓN DE ANEXOS</h5>
      </legend>

      <Local :disabled="disabled" />

      <TestEquipment
        :disabled="disabled"
        title="ANEXO 6. LISTADO DE EQUIPOS DE ENSAYO"
      />

      <ProfTestInter
        :disabled="disabled"
        :activity="activity"
        title="ANEXO 10. LISTADO DE INTERCOMPARACIONES Y/O ENSAYOS DE APTITUD"
      />

      <rehearsal-activities-table
        title="ANEXO 14. LISTADO DE PERSONAL RELACIONADO CON LA ACREDITACIÓN"
        tableId="rehearsal-activities-table"
        modalTitle="Añadir personal"
        editModalTitle="Editar personal"
        :activity="activity"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },

    disabled() {
      return (
        this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status.code != "100"
      );
    },
  },
};
</script>